import { CanisRestClient } from "@/util/rest/clients/canis-rest-client";

import { CryptoModels } from "./crypto.models";

export namespace CryptoApi {
  export const disperseReward = (data: CryptoModels.DisperseRewardRequest) => {
    return CanisRestClient.post(
      { resSchema: CryptoModels.DisperseRewardResponseSchema },
      `/crypto/disperse-reward`,
      data,
    );
  };

  export const getDisperseRewardStatus = () => {
    return CanisRestClient.get(
      { resSchema: CryptoModels.GetDisperseRewardStatusResponseSchema },
      `/crypto/disperse-reward-status`,
    );
  };

  export const getSymbols = () => {
    return CanisRestClient.get({ resSchema: CryptoModels.GetCryptoSymbolsResponseSchema }, `/crypto/symbols`);
  };

  export const getPositions = () => {
    return CanisRestClient.get({ resSchema: CryptoModels.GetCryptoPositionsResponseSchema }, `/crypto/positions`);
  };
}
